import React from 'react'

import { Marker, MarkerDragEvent, MarkerEvent } from 'react-map-gl/mapbox'

import DomPin from '~/client/src/shared/components/SitemapHelpers/components/DomPins/DomPin'
import { LOCATION_ICON_COMPONENTS } from '~/client/src/shared/components/SitemapHelpers/utils/markerSpec'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'

const ProjectIcon = LOCATION_ICON_COMPONENTS[MapViewLocationIcon.Project]

interface IProps {
  latitude: number
  longitude: number
  draggable?: boolean
  className?: string
  onProjectMarkerDrag?: (event: MarkerDragEvent) => void
  onProjectMarkerDragEnd?: (event: MarkerDragEvent) => void
  onClick?: (
    event:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | MarkerEvent<MouseEvent>,
  ) => void
}

export default class ProjectAddressMarker extends React.Component<IProps> {
  public render(): JSX.Element {
    const {
      className,
      latitude,
      longitude,
      draggable,
      onProjectMarkerDrag,
      onProjectMarkerDragEnd,
      onClick,
    } = this.props

    return (
      <Marker
        className={className}
        latitude={latitude}
        longitude={longitude}
        onDragStart={onProjectMarkerDrag}
        onDrag={onProjectMarkerDrag}
        onDragEnd={onProjectMarkerDragEnd}
        draggable={draggable}
        onClick={onClick}
      >
        {/* The click lives on the Marker, which also owns the drag surface. */}
        <DomPin
          fill="var(--primary)"
          stroke="white"
          glyph={({ size, color }) => <ProjectIcon size={size} color={color} />}
        />
      </Marker>
    )
  }
}
